export default __webpack_public_path__ + "static/media/1.008f66f9.png";